import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD537]/50 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-br from-[#FFD537] to-[#F9B438] text-[#1D1D1B] shadow-[0_4px_14px_rgba(255,213,55,0.35)] hover:shadow-[0_6px_20px_rgba(255,213,55,0.5)] hover:-translate-y-0.5 active:translate-y-0",
        destructive:
          "bg-red-500 text-white shadow-sm hover:bg-red-600",
        outline:
          "border-2 border-[#1D1D1B] bg-transparent text-[#1D1D1B] shadow-sm hover:bg-[#1D1D1B] hover:text-white",
        "outline-light":
          "border-2 border-white/40 bg-transparent text-white hover:bg-white/10 hover:border-white/60",
        secondary:
          "bg-[#1D1D1B] text-white shadow-[0_4px_14px_rgba(29,29,27,0.25)] hover:shadow-[0_6px_20px_rgba(29,29,27,0.35)] hover:-translate-y-0.5",
        ghost: "hover:bg-neutral-100 text-[#1D1D1B]",
        link: "text-[#1D1D1B] underline-offset-4 hover:underline hover:text-[#F9B438]",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-lg px-3 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
